export const projects = {
  // Hero Section
  heroTitle: '학생 프로젝트',
  heroSubtitle: '우주적 사고로 세상을 바꾸는 학생들의 도전',
  badge1: '100+ 완성된 프로젝트',
  badge2: '실제 문제 해결',
  badge3: '국제 대회 수상',

  // Category Filter
  categoryAll: '전체',
  categoryEarthScience: '지구 과학',
  categoryMoon: '달',
  categoryRovers: '로버',
  categoryMars: '화성',
  categorySpaceLife: '우주 생활',
  categoryStars: '별',
  categoryAI: 'AI',

  // Project 1
  project1Title: '지구 기후 시스템 연구',
  project1Students: '초등 4학년 3명',
  project1Description: 'Week 1 프로젝트: 지구 기후 패턴을 보여주는 인터랙티브 모델 제작',
  project1Achievement: '클래스 발표 우수상',
  project1Tag1: '기후',
  project1Tag2: '데이터 시각화',
  project1Tag3: '발표',

  // Project 2
  project2Title: '달 기지 설계',
  project2Students: '초등 5학년 4명',
  project2Description: 'Week 2 프로젝트: 달 거주지 3D 모델 설계 및 제작',
  project2Achievement: '최우수 설계상',
  project2Tag1: '디자인',
  project2Tag2: '3D 모델링',
  project2Tag3: '팀워크',

  // Project 3
  project3Title: '화성 탐사 로버',
  project3Students: '초등 4학년 2명',
  project3Description: 'Week 3 프로젝트: 센서가 있는 작동하는 로버 제작 및 프로그래밍',
  project3Achievement: '혁신상',
  project3Tag1: '로보틱스',
  project3Tag2: '프로그래밍',
  project3Tag3: '공학',

  // Project 4
  project4Title: '화성 생존 계획',
  project4Students: '초등 5학년 3명',
  project4Description: 'Week 4 프로젝트: 종합적인 화성 임무 생존 전략 수립',
  project4Achievement: '문제해결 우수상',
  project4Tag1: '문제 해결',
  project4Tag2: '리서치',
  project4Tag3: '계획',

  // Project 5
  project5Title: '우주 정거장 식량 시스템',
  project5Students: '초등 4학년 3명',
  project5Description: 'Week 5 프로젝트: 우주를 위한 지속 가능한 식량 생산 설계',
  project5Achievement: '창의성상',
  project5Tag1: '생물학',
  project5Tag2: '지속가능성',
  project5Tag3: '디자인',

  // Project 6
  project6Title: '별자리 지도 만들기',
  project6Students: '초등 5학년 2명',
  project6Description: 'Week 6 프로젝트: 신화 이야기가 담긴 상세한 별자리 지도 제작',
  project6Achievement: '예술성 우수상',
  project6Tag1: '천문학',
  project6Tag2: '미술',
  project6Tag3: '스토리텔링',

  // Project 7
  project7Title: 'AI 데이터 분석기',
  project7Students: '초등 4학년 3명',
  project7Description: 'Week 7 프로젝트: 우주 데이터 패턴을 분석하는 간단한 AI 제작',
  project7Achievement: '기술 혁신상',
  project7Tag1: 'AI',
  project7Tag2: '데이터 과학',
  project7Tag3: '코딩',

  // Project 8
  project8Title: '완전한 우주 임무',
  project8Students: '초등 5학년 4명',
  project8Description: 'Week 8 최종 프로젝트: 종합적인 화성 탐사 임무 계획',
  project8Achievement: '최종 프로젝트 최우수상',
  project8Tag1: '종합',
  project8Tag2: '계획',
  project8Tag3: '발표',

  // Testimonials Section
  testimonialsTitle: '학생',
  testimonialsTitleHighlight: '후기',
  testimonialsSubtitle: '프로젝트를 완성한 학생들의 이야기',

  testimonial1Name: '김서준',
  testimonial1Grade: '초등학교 5학년',
  testimonial1Project: '화성 탐사 로버',
  testimonial1Quote: 'EDUSPACE에서 직접 로버를 만들었어요! 처음엔 어려웠지만 선생님과 친구들이 도와줘서 완성했어요. 진짜 우주 과학자가 된 것 같았어요!',

  testimonial2Name: '박지우',
  testimonial2Grade: '초등학교 4학년',
  testimonial2Project: '지구 기후 연구',
  testimonial2Quote: '지구의 기후를 연구하면서 환경을 지키는 게 얼마나 중요한지 알았어요. 매주 발표하는 시간이 제일 재미있었어요!',

  testimonial3Name: '이하은',
  testimonial3Grade: '초등학교 5학년',
  testimonial3Project: 'AI 데이터 분석',
  testimonial3Quote: 'AI로 우주 데이터를 분석하는 게 신기했어요. 8주 동안 정말 많이 배웠고, 더 배우고 싶어요!',

  // CTA Section
  ctaTitle: '당신의',
  ctaTitleHighlight: '프로젝트',
  ctaSubtitle: '우주적 사고로 세상을 바꾸는 여정에 함께하세요',
  ctaButton1: '프로젝트 시작하기',
  ctaButton2: '커리큘럼 보기'
};
